import { CloseFilled } from "@carbon/icons-react";
import React from "react";
import styled from "styled-components";

const InternalStyledClearIcon = styled(CloseFilled)`
  cursor: pointer;
`;

const StyledClearIcon = ({
  withMargin,
  width,
  height,
  tabIndex,
  children,
  ...props
}: {
  withMargin?: boolean;
  width?: number;
  height?: number;
  tabIndex?: string;
  children: React.ReactNode;
}) => {
  return (
    <InternalStyledClearIcon
      size={20}
      width={width}
      height={height}
      tabIndex={tabIndex}
      style={withMargin ? { margin: "auto 10px" } : undefined}
      {...props}
    >
      {children}
    </InternalStyledClearIcon>
  );
};

export default StyledClearIcon;
